export default "__VITE_ASSET__BTBlwSMi__"